import { render, staticRenderFns } from "./InputNum.vue?vue&type=template&id=0fa2f070&scoped=true&"
import script from "./InputNum.vue?vue&type=script&lang=js&"
export * from "./InputNum.vue?vue&type=script&lang=js&"
import style0 from "./InputNum.vue?vue&type=style&index=0&id=0fa2f070&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2f070",
  null
  
)

export default component.exports